module.exports = __webpack_public_path__ + "static/media/IC222renew.84f71156.jpg";